import { TimeBasedSettingForCallersGroupDto } from '../../../dto/timebasedsetting/timebasedsettingforcallersgroupdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface TimeBasedSettingForCallersGroupRequest extends APIRequest
{
    getTimeBasedSettingForCallersGroupRequest(): TimeBasedSettingForCallersGroupDto;
}

export class TimeBasedSettingForCallersGroupRequestImpl extends APIRequestDtoImpl implements TimeBasedSettingForCallersGroupRequest
{
    constructor(private timeBasedSettingForCallersGroupData: TimeBasedSettingForCallersGroupDto)
    {
        super();
    }

    getTimeBasedSettingForCallersGroupRequest(): TimeBasedSettingForCallersGroupDto
    {
        return this.timeBasedSettingForCallersGroupData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgrouprequest.tsx